import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import { AuthenticationService } from '../../shared'

interface MfaSetupResponse {
    sharedKey?: string
    otpAuthUri?: string
    qrCodeDataUrl?: string
}

@Component({
    templateUrl: './mfa-setup.component.html',
    styleUrls: ['../sign-in/sign-in.component.css'],
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class MfaSetupComponent implements OnInit {
    faSpinner = faSpinner
    isLoading = true
    isSubmitting = false
    sharedKey = ''
    qrCodeDataUrl = ''
    code = ''
    recoveryCodes: string[] = []
    savedCodes = false
    failed = false
    rateLimited = false
    sessionMissing = false
    loadError = false

    private http = inject(HttpClient)
    private router = inject(Router)
    private authentication = inject(AuthenticationService)

    ngOnInit(): void {
        this.http.get<MfaSetupResponse>('api/Account/Mfa/Setup').subscribe({
            next: result => {
                this.sharedKey = result.sharedKey ?? ''
                this.qrCodeDataUrl = result.qrCodeDataUrl ?? ''
                this.isLoading = false
            },
            error: (err: HttpErrorResponse) => {
                this.isLoading = false
                if (err.status === 401) {
                    this.sessionMissing = true
                } else {
                    this.loadError = true
                }
            },
        })
    }

    submit() {
        this.failed = false
        this.rateLimited = false
        if (!this.code) return

        this.isSubmitting = true
        this.http.post<{ status?: string; recoveryCodes?: string[] }>('api/Account/Mfa/Enable', { code: this.code }).subscribe({
            next: result => {
                if (result?.status !== 'signedIn') {
                    this.failed = true
                    this.isSubmitting = false
                    return
                }
                this.recoveryCodes = result.recoveryCodes ?? []
                this.isSubmitting = false
            },
            error: (err: HttpErrorResponse) => {
                this.isSubmitting = false
                if (err.status === 401) {
                    this.sessionMissing = true
                } else if (err.status === 429) {
                    this.rateLimited = true
                } else {
                    this.failed = true
                }
            },
        })
    }

    continueToApp() {
        if (!this.savedCodes) return
        this.authentication.completeLogin().subscribe({
            next: () => {
                if (this.authentication.requestedRoute) {
                    this.router.navigateByUrl(this.authentication.requestedRoute)
                    this.authentication.requestedRoute = ''
                } else {
                    this.router.navigate([''])
                }
            },
        })
    }

    downloadCodes() {
        const blob = new Blob([this.recoveryCodes.join('\r\n')], { type: 'text/plain' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'webapps-mfa-recovery-codes.txt'
        link.click()
        URL.revokeObjectURL(url)
    }

    backToSignIn() {
        this.router.navigate(['signin'])
    }
}
